import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import PrintableOrderReport from '../printable/PrintableOrderReport'; // Correct path
import LoadingSpinner from '../../components/common/LoadingSpinner';

// Define the expected structure of the fetched report data
// (Should match the structure returned by getOrderReport)
interface OrderReportData {
  orders: Array<{
    id: number;
    number: string;
    client: {
      id: number;
      name: string;
      director?: string | null;
    };
    status: string;
    totalAmount: number;
    paidAmount: number;
    createdAt: Date | string;
    structures: Array<any>; // Use specific type if needed
  }>;
  statusBreakdown: Array<{ status: string; count: number; amount: number; percentage: number }>;
  totalRevenue: number;
  totalPaid: number;
  totalUnpaid: number;
  startDate: string;
  endDate: string;
}

const OrderReportPrintPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const startDate = searchParams.get('startDate');
  const endDate = searchParams.get('endDate');
  const status = searchParams.get('status'); // Get optional status filter

  const [reportData, setReportData] = useState<OrderReportData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchReportData = async () => {
      if (!startDate || !endDate) {
        setError('Не указан период для отчета.');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        // Use the new backend endpoint for order report print data
        const response = await axios.get<OrderReportData>(`/reports/orders/print-data`, {
          params: { startDate, endDate, status: status === 'all' ? undefined : status } // Pass filters
        });
        // Add startDate and endDate to the fetched data for the printable component
        setReportData({ ...response.data, startDate, endDate });
        // Attempt to trigger print dialog after data is loaded
        setTimeout(() => {
          // window.print();
        }, 500); // Small delay
      } catch (err: any) {
        console.error('Error fetching order report data for printing:', err);
        setError(err.response?.data?.message || 'Не удалось загрузить данные отчета для печати.');
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [startDate, endDate, status]); // Depend on query parameters

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="printable-container error-message">Ошибка: {error}</div>;
  }

  if (!reportData) {
    return <div className="printable-container">Данные для печати не найдены.</div>;
  }

  // Render the printable component with the fetched data
  return <PrintableOrderReport reportData={reportData} />;
};

export default OrderReportPrintPage;
